// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3l9FF","col":"CardReaderDesc_col__1kJlg","label":"CardReaderDesc_label__-PTs7"};